import type { CartV2LineItem } from '@Domains/Cart/Feature/CartV2/CartV2'

type CurrencyRate = { key: string, value: number }

const TARGET_CURRENCIES = ['DKK', 'EUR', 'USD'] as const

export const toMultiCurrency = (
  value: number,
  storeCurrency: string | undefined | null,
  rates: ReadonlyArray<CurrencyRate | null> | undefined | null,
  fieldPrefix = 'value',
): Record<string, number | undefined> => {
  const out: Record<string, number | undefined> = {}
  TARGET_CURRENCIES.forEach((target) => {
    const key = `${fieldPrefix}_${target.toLowerCase()}`
    if (!storeCurrency) {
      out[key] = undefined
      return
    }
    if (target === storeCurrency) {
      out[key] = value
      return
    }
    const rate = rates?.find(r => r?.key === target)?.value
    out[key] = rate != null ? Math.round(value * rate * 100) / 100 : undefined
  })
  return out
}

export const lineItemToGA4Item = (
  lineItem: CartV2LineItem,
  storeCurrency: string | undefined | null,
  rates: ReadonlyArray<CurrencyRate | null> | undefined | null,
  quantityOverride?: number,
) => {
  const qty = lineItem.quantity || 1
  const lineDiscount = lineItem.totalPrice?.discount ? parseFloat(lineItem.totalPrice.discount?.plain || '0') : 0
  const unitPrice = parseFloat(lineItem.totalPrice?.plain || '0') / qty
  const unitDiscount = lineDiscount / qty
  return {
    item_id: lineItem.product?.id,
    item_name: lineItem.product?.name || '',
    item_brand: lineItem.product?.brand?.title || '',
    item_category: lineItem.product?.primaryCategories?.[0]?.name || '',
    item_category2: lineItem.product?.primaryCategories?.[1]?.name || '',
    price: unitPrice,
    quantity: quantityOverride ?? qty,
    discount: unitDiscount,
    ...toMultiCurrency(unitPrice, storeCurrency, rates, 'price'),
    ...toMultiCurrency(unitDiscount, storeCurrency, rates, 'discount'),
  }
}
